import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class ContactPayshapAccountService {

  constructor(private http: HttpClient) {}

  postPayshapAccount(userSession: string, contactId: string, bankId: string, accountNumber: string, requestType: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      contactId,
      bankId,
      accountNumber,
      requestType
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/ContactBankAccount/add-account`,
      request,
      {
        headers
      }
    );
  }
}